/* eslint-disable @typescript-eslint/naming-convention */
import * as actions from "#/modules/dashboard/redux/actionType";
import { ReduxActionType } from "#/types/ActionType";

export const getLicense = (token: string): ReduxActionType<string> => ({
  type: actions.GET_LICENSE,
  data: token,
});

export const getUnsafeRequests = (data: {
  accessToken: string;
  service_token_id?: string;
}): ReduxActionType<{ accessToken: string; service_token_id?: string }> => ({
  type: actions.GET_UNSAFE_REQUESTS,
  data,
});

export const getTraceDetail = (data: {
  accessToken: string;
  traceId: string;
}): ReduxActionType<{ accessToken: string; traceId: string }> => ({
  type: actions.GET_TRACE_DETAIL,
  data,
});

export const getDashboardData = (data: {
  accessToken: string;
  period: number;
  timezone?: string;
}): ReduxActionType<{ accessToken: string; period: number; timezone?: string }> => ({
  type: actions.GET_DASHBOARD_DATA,
  data,
});

export const getStatsSummary = (data: {
  accessToken: string;
  service_token_id?: string;
}): ReduxActionType<{
  accessToken: string;
  service_token_id?: string;
}> => ({
  type: actions.GET_STATS_SUMMARY,
  data,
});

export const getTraceRecords = (data: {
  accessToken: string;
  service_token_id?: string;
  cursor?: string;
  limit?: number;
  violated_types?: string;
  violated_policy_names?: string;
}): ReduxActionType<{
  accessToken: string;
  service_token_id?: string;
  cursor?: string;
  limit?: number;
  violated_types?: string;
  violated_policy_names?: string;
}> => ({
  type: actions.GET_TRACE_RECORDS,
  data,
});

export const resetTraceRecords = (): { type: string } => ({
  type: actions.RESET_TRACE_RECORDS,
});

export const getPolicyNameMapping = (token: string): ReduxActionType<string> => ({
  type: actions.GET_POLICY_NAME_MAPPING,
  data: token,
});
